export class UserType {
    static SUPERADMIN = new UserType("superadmin")
    static AGENCE_ADMIN = new UserType("agence_admin")
    static PARTICULIER = new UserType("particulier")
    static COLLABORATEUR = new UserType("collaborateur")

    value;

    constructor(value) {
        this.value = value;
    }

    static values() {
        return [this.SUPERADMIN, this.AGENCE_ADMIN, this.PARTICULIER, this.COLLABORATEUR];
    }

    static fromValue(value) {
        for (let userType of UserType.values()) {
            if(userType.value === value) {
                return userType;
            }
        }

        throw new Error("impossiblde de trouver le type d'utilisateur " + value)
    }
}